import { ButtonProps, ImageNameType } from '@oy/ui';
import { FontStyleEnums } from '@oy/uicore';
import { IconName, ProductFeatureIconName } from '@oy/uiicon';
import { Ref } from 'react';

type EmptyStateArticle = {
  title: string;
  description: string;
  onClickPrimaryButton?: () => void;
  primaryButtonName?: string;
  onClickSecondaryButton?: () => void;
  secondaryButtonName?: string;
};

type EmptyStateYoutube = {
  title: string;
  imagePreview: ImageNameType;
  videoId: string;
};

type ButtonType = ButtonProps & {
  ref?: Ref<HTMLButtonElement>;
};

type TextType = React.HTMLProps<HTMLDivElement> & {
  textStyle: FontStyleEnums;
};

type ButtonIconType = ButtonType & {
  iconName: IconName;
  productFeatureIconName?: ProductFeatureIconName;
};

export type EmptyStateInfo = {
  title?: string;
  detail?: React.ReactNode;
  buttons?: EmptyStateActionButtons;
  productTranslation?: string;
  imageName?: ImageNameType;
  stylesImage?: React.CSSProperties;
  headerProps?: TextType;
  descriptionProps?: TextType;
  actionButtons?: ButtonType[];
};

export enum EmptyStateType {
  DEFAULT = 'default',
  NOT_FOUND = 'notFound',
  ADVANCE_SEARCH = 'advanceSearch',
  SIMPLE_CUSTOM_IMAGE = 'simpleCustomImage',
  ERROR_RETRIEVE_DATA = 'errorRetrieveData',
}

export type EmptyStateProps = React.HTMLProps<HTMLDivElement> & {
  type?: EmptyStateType;
  contents?: EmptyStateContentType[];
  sourcePage?: string;
} & EmptyStateInfo;

export type EmptyStateActionButtons = {
  advanceSearchButtons?: ButtonType[];
  mainButton?: ButtonIconType;
  supportButton?: ButtonType;
};

export type EmptyStateContentType = {
  imageName: ImageNameType;
  article: EmptyStateArticle;
  youtube?: EmptyStateYoutube;
  source_page?: string;
};
